// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 491) return "bundle/hero.js";
	if (chunkId === 705) return "bundle/imageFull.js";
	if (chunkId === 171) return "bundle/numbers.js";
	if (chunkId === 138) return "bundle/138.js";
	if (chunkId === 842) return "bundle/editorial.js";
	if (chunkId === 749) return "bundle/frames.js";
	if (chunkId === 904) return "bundle/productIndex.js";
	if (chunkId === 303) return "bundle/productDetail.js";
	if (chunkId === 369) return "bundle/stickybar.js";
	if (chunkId === 762) return "bundle/masthead.js";
	if (chunkId === 116) return "bundle/highlights.js";
	if (chunkId === 912) return "bundle/contacts.js";
	if (chunkId === 897) return "bundle/carousel.js";
	if (chunkId === 939) return "bundle/sliderFull.js";
	if (chunkId === 396) return "bundle/audioPlayer.js";
	if (chunkId === 507) return "bundle/prototype.js";
	if (chunkId === 979) return "bundle/magazineIndex.js";
	if (chunkId === 902) return "bundle/magazineDetail.js";
	if (chunkId === 285) return "bundle/sliderRelated.js";
	if (chunkId === 72) return "bundle/72.js";
	if (chunkId === 522) return "bundle/maps.js";
	if (chunkId === 802) return "bundle/mapsInfo.js";
	if (chunkId === 757) return "bundle/mapsWineyard.js";
	if (chunkId === 286) return "bundle/stickyButton.js";
	// return url for filenames based on template
	return undefined;
};